import { Link } from "react-router-dom";

const Y_PATH = "M191 516H702L813 960H827L957 516H1463L1195 1240C1110 1470 990 1568 740 1568C600 1568 450 1566 313 1556V1232C420 1244 560 1246 680 1246C740 1246 767 1236 767 1215V1198H630C500 1198 395 1160 370 1080Z";

export const YMark = ({ className = "h-10 w-10", color = "#e9458f" }) => (
  <svg viewBox="180 500 1295 1080" className={className} aria-hidden="true">
    <path d={Y_PATH} fill={color} />
  </svg>
);

export const Logo = ({ light = false }) => (
  <Link to="/" data-testid="header-logo-link" className="group flex items-center gap-3">
    <YMark className="h-10 w-10 transition-transform duration-500 group-hover:-rotate-12" />
    <span className={`font-mono text-[11px] uppercase leading-tight tracking-[0.25em] ${light ? "text-[#f4ede6]" : "text-[#1c1418]"}`}>
      Youth<br />Management
    </span>
  </Link>
);
